/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { ReactNode } from "react";

import OptionalTooltip from "@/components/Tooltip/OptionalTooltip";

import { colors } from "@dotnet/telematics-design-system";

interface DescriptionItemProps {
  label: string;
  children: ReactNode;
  tooltipText?: string;
}

const DescriptionItem = ({
  label,
  children,
  tooltipText
}: DescriptionItemProps) => {
  return (
    <div
      css={{
        display: "flex",
        gap: "4px"
      }}
    >
      <span css={css({ color: colors.textPlaceholder })}>{label}:</span>
      <OptionalTooltip
        isDisabled={!tooltipText}
        tooltipTitle={tooltipText ?? ""}
        tooltipPlacement="top"
        disableInteractive
        disableTouchListener
      >
        <span css={css({ color: colors.textDark })}>{children}</span>
      </OptionalTooltip>
    </div>
  );
};

export default DescriptionItem;
